import { Company } from "./Company";

export class ToolCounter {
  toolsDueServiceCount: number;
  toolsDueCalibrationCount: number;
  toolsAwatingPoCount: number;

  constructor(public company?: Company) {}
}
